<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white letter-spacing privacy-policy-card"
  >
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Before you register and conduct or download
        <strong>Adlash</strong> downloadable product(s) for your motives, please
        ensure you have read, acknowledged, and accepted all the terms. By using
        <strong>Adlash</strong> and/or other items, we believe you have agreed
        to the following terms and conditions.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Last updated on February 3, 2024.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Hi there, we’re <strong>Adlash</strong>, and welcome to our privacy
        policy which also applies to our customers.
        <br />
        This policy sets out how we handle your personal information if you’re
        an <strong>Adlash</strong> user or visitor to our site.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        When we say ‘we’, ‘us’, or <strong>‘Adlash’</strong>, it’s because
        that’s who we are and we own and run the site.
        <br />
        If we say ‘policy’ we’re talking about this privacy policy. If we say
        ‘user terms’ we’re talking about the rules for using the site. The rules
        vary by product; each product makes them separately available and seeks
        consent to them separately to this policy.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        The type of personal information we collect
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We collect certain personal information about visitors and users of our
        site.
        <br />
        The most common types of information we collect include things like:
        user-names, member names, email addresses, other contact details,
        support queries, and item comments (if applicable).
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        How we collect personal information
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We collect personal information directly when you provide it to us,
        automatically as you navigate through the site.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We collect your personal information when you provide it to us when you
        complete membership registration and buy items or services on our site,
        subscribe to a newsletter, email list, submit feedback or send us a
        communication.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        How we use personal information
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        This data is intended to identify you as our
        <a href="#" class="text-decoration-none">customer/subscriber</a> and
        deliver products/information and other marketing elements. Visitors
        aren’t allowed to purchase any product or subscribe to the newsletter or
        make a comment anonymously. So, this information is the only means we
        can identify you and allow you to make these actions on the site.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        When we disclose your personal information
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We won’t disclose your data to third parties in a way as to reveal any
        of your personal information like email, name, etc. (subject to laws and
        regulations). Only our <i>authorities</i> have access to your data and
        no third-party access to your data from us.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        How we keep your personal information secure
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We store personal information on secure servers managed by us, and our
        service providers and files are kept in a secure location. Personal
        <a href="#" class="text-decoration-none" target="_blank">information</a>
        that we store is protected by security and access controls, including
        username and password authentication, two-factor authentication, and
        data encryption where appropriate.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        How you can access your personal information
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        You can access some of the personal information we collect by logging in
        to your account. You also have the right to request access to other
        personal information we hold about you and to request corrections of any
        errors in that data. Contact our support using the contact details to
        make an access or correction request.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        Marketing Choices regarding your personal information
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Where we have your consent to do so (e.g., if you have subscribed to one
        of our email lists or have indicated that you are interested in
        receiving offers or information from us), we send you marketing
        communications by email about products and services that we feel may be
        of interest to you. You can ‘opt-out’ of such communications if you
        prefer not to receive them in the future by using the “unsubscribe”
        facility provided in the communication.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        You also have choices about <u>cookies</u>, as described below. By
        modifying your browser preferences, you can accept all cookies, be
        notified when a cookie is set, or reject all cookies. If you reject
        cookies, some parts of our site may not work properly in your case.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        Cookies (not the type you eat!) and web analytics
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We use cookies to identify and track visitors, their actions on the
        site, and their website access preferences. These cookies contain
        visitors’ IP and time of visits. <strong>Adlash</strong> visitors who do
        not wish to have cookies placed on their browsers should set their
        browsers to refuse cookies before using the
        <strong>Adlash</strong> site.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        How long we keep your personal information
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We retain your personal information for as long as is necessary to
        provide the services to you and others and to comply with our legal
        obligations. If you no longer want us to use your personal information
        or to provide you with the <strong>Adlash</strong> services, you can
        request that we erase your personal information and close your account.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">
        When we need to update this policy
      </h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        We will need to change this policy from time to time to ensure it stays
        up to date with the latest legal requirements and any changes to our
        privacy management practices. When changing the policy, we will notify
        you about such changes; where required, a copy of the latest version of
        this policy will always be available on this page.
      </p>
      <h5 class="text-black fw-bold mb-10 mb-12">How you can contact us</h5>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        If you have any questions about our privacy practices or how we have
        been managing your personal information, please get in touch with our
        support at
        <a href="mailto:hello@adlash.com" class="text-decoration-none">
          hello@adlash.com </a
        >.
      </p>
      <p class="text-paragraph fs-md-15 fs-lg-16 lh-base">
        Both personal information and personal data have the same meaning in the
        context of this Privacy Policy.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>
